/**
 * Generates an array containing all weeks in a given range.
 * Weeks start on the first minute of Monday and end on the last minute of Sunday 
 * @param {Date} startDate start date of range
 * @param {Date} endDate end date of range
 * @returns {[*]} array of weeks
 */
export function getWeeksInRange(startDate, endDate) {
  const weeks = [];
  const start = new Date(startDate);
  const end = new Date(endDate);

  // Set the start date to the first Monday on or before the given start date
  start.setDate(start.getDate() - (start.getDay() || 7) + 1);
  start.setHours(0, 0, 0, 0);

  // Loop through each week until we reach or pass the end date
  while (start < end) {
      const weekStart = new Date(start);
      const weekEnd = new Date(start);
      weekEnd.setDate(weekEnd.getDate() + 6);
      weekEnd.setHours(23, 59, 59, 999);

      weeks.push({ startDate: weekStart, endDate: weekEnd });

      // Move to the next Monday
      start.setDate(start.getDate() + 7);
  }

  return weeks;
}

/**
 * checks whether a date is within a range of two dates
 * @param {Date|string} date date to check
 * @param {Date|string} startDate start date of range
 * @param {Date|string} endDate end date of range
 * @returns 
 */
export function isDateInRange(date, startDate, endDate) {
  return new Date(date) >= new Date(startDate) && new Date(date) <= new Date(endDate);
}